export const DISCORD_INVITE_LINK = "https://discord.gg/JupwzYvvfH";
export const DOCUMENTATION_LINK = "https://docs.justpush.io/introduction";
export const DOCUMENTATION_MESSAGE_LINK = `${DOCUMENTATION_LINK}/objects/messages`;
export const DOCUMENTATION_TOPICS_LINK = `${DOCUMENTATION_LINK}/objects/topics`;
export const MAILTO_LINK = "mailto:info@justpush.io";